import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import AnimationComponent from '../../Component/Animation';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';

export default class Suitcase extends GameObject {
    protected onCreate(params: { x: number; y: number }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'suitcase_close',
            anchor: new Point(0.5, 1),
        });
        this.addChild(baseSprite);

        baseSprite.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'SuitcaseIdle',
        });

        // Add the speech bubble.
        const speechBubble: SpeechBubble = GameObject.Instantiate(SpeechBubble, {
            x: -50,
            y: -120,
            text: Game.locale.getText('FindMe'),
            textStyle: Game.style.getStyle('suitcase.text'),
        });
        this.addChild(speechBubble);
    }
}
